import { getPlatform } from '@/static/js/zjs'
import request from '../static/js/request'
const appid = getPlatform().appid
// 查询抽奖活动 open/lottery/referenced/activity/findActivity
export function getLuckyDrawfindActivity(data) {
  return request.get(`/mopa/api-internet-user/open/lottery/referenced/activity/findActivity`, {
    params: {
      appid,
      ...data
    }
  })
}
// 校验活动是否结束(如果结束会返回活动结束弹框信息) open/lottery/referenced/activity/checkActivityIsOver
export function getLuckyDrawCheckActivityIsOver(params) {
  return request.get(
    `/mopa/api-internet-user/open/lottery/referenced/activity/checkActivityIsOver`,
    { params }
  )
}
// 抽奖  open/lottery/referenced/activity/draw
export function getLuckyDrawCheckReferenced(data) {
  return request.post(`/mopa/api-internet-user/open/lottery/referenced/activity/draw`, data)
}
// 我的奖品列表 open/lottery/user/draw/my_prizes/{appid}/{openid}
export function getLuckyDrawfindmyPrizes(openid, params) {
  return request.get(
    `/mopa/api-internet-user/open/lottery/user/draw/my_prizes/${appid}/${openid}`,
    {
      params
    }
  )
}
// 虚拟奖品权益发放接口 /open/lottery/user/draw/issuanceOfUserRights
export function getLuckyDrawfindmyIssuanceOfUserRights(data) {
  return request.post(`/mopa/api-internet-user/open/lottery/user/draw/issuanceOfUserRights`, data)
}
